<!-- <app-header position="fixed-top" [showBackButton]="false"></app-header> -->
<banner-app
  [Fixtop]="''"
  [retroSelected]="true"
  [infoDueno]="true"
  [showPromo]="true"
></banner-app>
<section class="bg-fondo-3 financed_section spacing-section spacing-top">
    <div class="container">

        <app-details-vehicle-banner></app-details-vehicle-banner>

        <h1 class="my-5 main-title">¿Qué banco tiene la prenda de tu moto?</h1>

        <app-financed-vehicle></app-financed-vehicle>

    </div>
</section>
<app-footer-app class="footer-fixed" />